import { Component, OnInit, ViewChild, Input, AfterViewInit, effect, Injector, DestroyRef, inject } from "@angular/core";
import { Location } from "@angular/common";
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MenuItem, TreeNode } from 'primeng/api';
import { MessageService, ConfirmationService } from 'primeng/api';

import { DialogService } from 'primeng/dynamicdialog';
import { ItemMin } from '../../entites/item-min';
import { ItemService } from '../../services/item-service';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../../base/base-component';
import { Item } from '../../entites/item';
import { Inventaire } from '../../entites/inventaire';
import { NoteEntite } from '../../entites/note';
import { Fournisseur } from 'src/app/entites/fournisseur';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ValeurAttribut } from 'src/app/entites/valeur-attribut';
import { CategorieMin } from 'src/app/entites/categorie';
import { SousCategorieEntite } from 'src/app/entites/sousCategorie';
import { ProfilService } from 'src/app/services/profil-service';
import { RapportService } from 'src/app/services/rapport-service';
import { DatePipe } from '@angular/common';
import { OptionsImpression } from 'src/app/entites/options-impression';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { PrixFournisseurEntite } from 'src/app/entites/prix-fournisseur';
import { ItemBonCommande } from 'src/app/entites/item-bon-commande';
import { AchatService } from 'src/app/services/achat-service';
import { CreationCommandeComponent, ResultatCreationBonCommande } from 'src/app/controles/creation-commande.component';
import { AttributService } from 'src/app/services/attribut-service';

import { GarantieEntite, TypeGarantieEntite } from 'src/app/entites/garantie';
import { ContextMenu } from 'primeng/contextmenu/public_api';
import { GarantieService } from 'src/app/services/garantie-service';


import { AppMainComponent } from 'src/app/app.main.component';
import { NoteService } from 'src/app/services/note-service';
import { HistoriqueItem } from 'src/app/entites/historiqueItem';
import { AjustementInventaireComponent, ResultatAjustementInventaire } from 'src/app/controles/ajustement-inventaire.component';

import { LiaisonService } from 'src/app/services/liaison-service';
import { SoumissionEntite } from 'src/app/entites/soumission';
import { SoumissionService } from 'src/app/services/soumission-service';
import { CompagnieEntite } from 'src/app/entites/compagnie';
import { LocalisationEntrepotEntite } from 'src/app/entites/localisation-entrepot';
import { TypeFacturationEntite } from 'src/app/entites/type-facturation';
import { ReleveHeureEntite } from 'src/app/entites/releve-heures';

import { ReparationService } from 'src/app/services/reparation-service';
import { DocumentService } from 'src/app/services/document-service';
import { DocumentEntite } from 'src/app/entites/document';
import { ContexteService } from 'src/app/services/contexte-service';
import { SelectionDelaiComponent } from 'src/app/controles/selection-delai.component';

import { RequisitionService } from 'src/app/services/requisition-service';
import { Emplacement } from 'src/app/entites/emplacement';
import { ETypesRequisition } from 'src/app/entites/enums/type-requisition';
import { ReparationEntite } from 'src/app/entites/reparation';
import { DocumentLieEntite } from 'src/app/entites/document-lie';
import { EntretienPreventifEntite } from 'src/app/entites/mecanique/entretien-preventif';
import { EntretienCorrectifEntite } from 'src/app/entites/mecanique/entretien-correctif';
import { HistoriqueEntretienComponent } from 'src/app/controles/mecanique/historique-entretien.component';
import { DetailEntretienCorrectifComponent } from 'src/app/controles/mecanique/detail-entretien-correctif.component';
import { VadEntite } from 'src/app/entites/mecanique/verification-avant-depart';
import { VadService } from 'src/app/services/vad-service';
import { DetailVadComponent } from 'src/app/controles/mecanique/detail-vad.component';
import { AssignerEntretiensComponent } from '../mecanique/bonsTravail/controles/assigner-entretiens.component';
import { ReleveKmEntite } from 'src/app/entites/releve-kms';
import { EntretienCorrectifService } from 'src/app/services/entretien-correctif-service';
import { BonTravailService } from 'src/app/services/bon-travail-service';
import { enrichirPrenomNomBonTravails } from 'src/app/utils/employe-nom-complet';
import { EntretienPreventifService } from 'src/app/services/entretien-preventif-service';
import { PieceUniteEntite } from 'src/app/entites/piece-unite';
import { PieceService } from 'src/app/services/piece-service';
import { HistoriquePosePieceComponent } from 'src/app/controles/mecanique/historique-pose-piece.component';
import { SelectionSimplePieceComponent } from 'src/app/controles/mecanique/selection-simple-piece.component';
import { DetailPieceUniteComponent } from 'src/app/controles/mecanique/detail-piece-unite.component';
import { ConsulterFournisseursComponent } from 'src/app/controles/consulter-fournisseurs.component';
import { CategorieEntretienEntite } from 'src/app/entites/mecanique/categorie-entretien';
import { AjoutFournisseurPieceComponent } from 'src/app/controles/mecanique/ajout-fournisseur-piece.component';
import { SelectionMutipleUniteMecaniqueComponent } from 'src/app/controles/mecanique/selection-multiple-unite-mecanique.component';
import { SelectionCategorieEntretienComponent } from 'src/app/controles/mecanique/selection-categorie-entretiendetail-piece-unite.component';
import { BonTravailEntite } from 'src/app/entites/mecanique/bon-travail';
import { AjustementsComponent } from '../mecanique/heures/controles/ajustements.component';
import { AjouterHeureComponent } from '../mecanique/heures/controles/ajouter-heure.component';
import { AnalyseItemComponent } from 'src/app/controles/analyse-item.component';
import { ModifierFournisseurPieceComponent } from 'src/app/controles/mecanique/modifier-fournisseur-piece.component';
import { AjouterKmComponent } from '../mecanique/heures/controles/ajouter-km.component';
import { HeureService } from 'src/app/services/heure-service';
import { KmService } from 'src/app/services/km-service';
import { AjustementsKmComponent } from '../mecanique/heures/controles/ajustements-km.component';
import { DepartementMecaniqueEntite } from 'src/app/entites/mecanique/departement-mecanique';
import { ConsulterPiecesComponent } from 'src/app/controles/consulter-pieces.component';
import { SelectionEntretienPreventifComponent } from 'src/app/controles/mecanique/selection-entretien-preventif.component';
import { ETypeLien } from 'src/app/entites/enums/type-lien-document';
import { SignalWithWatcher } from "src/app/services/base.service";
import { ETypeChampAttribut } from "src/app/entites/enums/type-champ";
import { ETypeFichier } from "src/app/entites/enums/type-fichier";
import { HttpEventType } from "@angular/common/http";
import { Emprunt } from "src/app/entites/emprunt";
import { EmpruntService } from "src/app/services/emprunt.service";

import { RequisitionMin } from "src/app/entites/requisition-min";


import { Requisition } from "src/app/entites/requisition";
import { ResultatSelectionItemSimple, SelectionItemSimpleComponent } from "src/app/controles/selection-item-simple.component";
import { ETypeFavori } from "src/app/entites/enums/type-favori";

@Component({
    selector: 'app-detail-item',
    templateUrl: './detail-item.component.html',
    styleUrls: ['./detail-item.component.scss'],
    providers: [MessageService, DialogService, DatePipe]
})
export class DetailItemComponent extends BaseComponent implements OnInit, AfterViewInit {

    afficherDetailBdc: boolean = false;
    detailBdcId: number;

    @Input('itemId') inputItemId: number;

    //GÉNÉRAL

    itemId: number;
    item: SignalWithWatcher<Item>;
    photoPrincipale: DocumentEntite;
    injector = inject(Injector);

    menu: MenuItem[];

    modeApercu: boolean = false;


    tabIndex = this.createParamSignal('tab', 0);

    listeCategories: CategorieMin[];
    listeSousCategoriesComplet: SousCategorieEntite[];
    listeSousCategories: SousCategorieEntite[];
    listeCompagnies: CompagnieEntite[];
    listeLocalisations: LocalisationEntrepotEntite[];

    listeTypesFacturation: TypeFacturationEntite[];
    listeDepartementsMecanique: DepartementMecaniqueEntite[];

    filtresCategorieEntretien: string[];
    filtresStatut: string[];

    // ATTRIBUTS

    chargementCompleteAttributs: boolean = false;
    attributs: ValeurAttribut[];
    nbAttributsRenseignes: number = 0;
    nbAttributsTotal: number = 0;

    // INVENTAIRE

    chargementCompleteInventaire: boolean = false;
    selectionInventaire: Inventaire;
    contenuMenuContextuelInventaire: MenuItem[];
    @ViewChild('menuContextuelInventaire') menuContextuelInventaire: ContextMenu;

    // HISTORIQUE

    chargementCompleteHistorique: boolean = false;
    selectionHistorique: HistoriqueItem;
    contenuMenuContextuelHistorique: MenuItem[];
    historiqueFiltre: HistoriqueItem[] = [];
    @ViewChild('menuContextuelHistorique') menuContextuelHistorique: ContextMenu;

    // HEURES / KM

    chargementCompleteRelevesHeure: boolean = false;
    selectionReleveHeure: ReleveHeureEntite;
    selectionReleveKm: ReleveKmEntite;
    contenuMenuContextuelReleveHeure: MenuItem[];
    contenuMenuContextuelReleveKm: MenuItem[];
    @ViewChild('menuContextuelReleveHeure') menuContextuelReleveHeure: ContextMenu;
    @ViewChild('menuContextuelReleveKm') menuContextuelReleveKm: ContextMenu;

    // FOURNISSEURS

    
    //dateJour = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:s');
    dateJour: Date = new Date(new Date().setHours(0,0,0,0));
    

    chargementCompletePrixFournisseurs: boolean = false;
    selectionPrixFournisseur: PrixFournisseurEntite;
    contenuMenuContextuelFournisseur: MenuItem[];
    @ViewChild('menuContextuelFournisseur') menuContextuelFournisseur: ContextMenu;

    // ACHATS

    chargementCompleteAchats: boolean = false;
    selectionAchat: ItemBonCommande;
    contenuMenuContextuelAchat: MenuItem[];
    @ViewChild('menuContextuelAchat') menuContextuelAchat: ContextMenu;

    // SOUMISSIONS

    chargementCompleteSoumissions: boolean = false;
    selectionSoumissions: SoumissionEntite;
    contenuMenuContextuelSoumissions: MenuItem[];
    @ViewChild('menuContextuelSoumissions') menuContextuelSoumissions: ContextMenu;

    // ASSOCIATIONS

    chargementCompleteAssociations: boolean = false;
    contenuMenuContextuelAssociation: MenuItem[];
    @ViewChild('menuContextuelAssociation') menuContextuelAssociation: ContextMenu;

    // DOCUMENTS

    chargementCompleteDocuments: boolean = false;
    documentsComplet: DocumentEntite[];
    typesDocuments: TreeNode[];
    selectionTypeDocument: TreeNode;

    // LIAISONS

    chargementCompleteDocumentsLies: boolean = false;
    selectionDocumentLie: DocumentLieEntite;
    contenuMenuContextuelDocumentLieEntite: MenuItem[];
    @ViewChild('menuContextuelDocumentLieEntite') menuContextuelDocumentLieEntite: ContextMenu;


    // LIAISONS

    chargementCompleteLiaisons: boolean = false;
    selectionLiaison: ItemMin;
    contenuMenuContextuelLiaison: MenuItem[];
    @ViewChild('menuContextuelLiaison') menuContextuelLiaison: ContextMenu;
    liaisonsOrgChart: TreeNode[] = [];

    // GARANTIES

    chargementCompleteGaranties: boolean = false;
    selectionGarantie: GarantieEntite;
    garantie: GarantieEntite;
    dialogueGarantieOuvert: boolean = false;
    dialogueGarantieBloque: boolean = false;
    grantieSubmitted: boolean = false;
    typesGarantie: TypeGarantieEntite[];
    selectionTypeGarantie: TypeGarantieEntite;
    contenuMenuContextuelGarantie: MenuItem[];
    @ViewChild('menuContextuelGarantie') menuContextuelGarantie: ContextMenu;
    @ViewChild('dialogueGarantie') dialogueGarantie;


    // NOTES

    chargementCompleteNotes: boolean = false;
    selectionNote: NoteEntite;
    note: NoteEntite;
    dialogueNoteOuvert: boolean = false;
    dialogueNoteBloque: boolean = false;
    noteSubmitted: boolean = false;
    contenuMenuContextuelNote: MenuItem[];
    @ViewChild('menuContextuelNote') menuContextuelNote: ContextMenu;
    @ViewChild('dialogueNote') dialogueNote;
    @ViewChild('champNote') champNote;


    // ENTRETIENS

    chargementCompleteEntretiens: boolean = false;
    chargementCompleteBonsTravail: boolean = false;
    chargementCompleteEntretiensPreventifs: boolean = false;
    chargementCompleteEntretiensCorrectifs: boolean = false;
    chargementCompleteVad: boolean = false;
    chargementCompletePieces: boolean = false;
    selectionEntretiensPreventifs: EntretienPreventifEntite[];
    selectionEntretiensCorrectifs: EntretienCorrectifEntite[];
    tabIndexEntretiens: number = 0;
    afficherHeures: boolean = true;
    afficherKms: boolean = true;
    afficherMois: boolean = true;
    calculEnCours: boolean = false;
    nbBdtEnCours: number;
    nbSoumissionsEnCours: number;
    contenuMenuContextuelEntretiensPreventifs: MenuItem[];
    
    entretiensCorrectifsFiltrees: EntretienCorrectifEntite[];
    selectionCategorieEntretienCorrectifs: CategorieEntretienEntite;

    @ViewChild('menuContextuelEntretiensPreventifs') menuContextuelEntretiensPreventifs: ContextMenu;
    contenuMenuContextuelEntretiensCorrectifs: MenuItem[];
    @ViewChild('menuContextuelEntretiensCorrectifs') menuContextuelEntretiensCorrectifs: ContextMenu;
    contenuMenuContextuelVads: MenuItem[];
    @ViewChild('menuContextuelVads') menuContextuelVads: ContextMenu;
    contenuMenuContextuelPieces: MenuItem[];
    @ViewChild('menuContextuelPieces') menuContextuelPieces: ContextMenu;

    //ENTRETIENSD - PIEECES

    piecesFiltrees: PieceUniteEntite[];
    listeCategoriesEntretien: CategorieEntretienEntite[];
    selectionCategorieEntretien: CategorieEntretienEntite;

    // ENTRETIEN - HISTORIQUE ACHAT  PIECES

    chargementCompleteHistoriqueAchatPieces: boolean = false;
    contenuMenuContextuelHistoriqueAchatPieces: MenuItem[];
    @ViewChild('menuContextuelHistoriqueAchatPieces') menuContextuelHistoriqueAchatPieces: ContextMenu;

    // ENTRETIEN - HISTORIQUE ENVOI PIECES

    chargementCompleteHistoriquePieces: boolean = false;
    contenuMenuContextuelHistoriquePieces: MenuItem[];
    @ViewChild('menuContextuelHistoriquePieces') menuContextuelHistoriquePieces: ContextMenu;



    dialogueImpression = false;
    optionsImpression: OptionsImpression = {
        identification: true,
        attributs: true,
        historique: false,
        inventaire: false,
        liaisons: false,
        achats: false,
        fournisseurs: false,
        garanties: false,
        notes: false
    }

    @ViewChild('tabView') tabView;
    @ViewChild('tabViewEntretiens') tabViewEntretiens;
    @ViewChild('panelNavigationDirecte') panelNavigationDirecte;
    @ViewChild('champNavigationDirecte') champNavigationDirecte;

    // Add property for current user name
    nomUtilisateur: string;

    // QR Code functionality
    qrCodeData: string = '';
    showQrCode: boolean = false;
    currentDate: Date = new Date();
    qrCodeImageUrl: string = '';
    printFormat: 'normal' | 'ptouch' = 'normal';

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent, private location: Location, 
        private breadcrumbService: BreadcrumbService,
        private ItemsService: ItemService,
        private rapportService: RapportService,
        private messageService: MessageService,
        public fournisseurService: FournisseurService,
        private heureService: HeureService,
        private kmService: KmService,
        private reparationService: ReparationService,
        private documentService: DocumentService,
        private entretienPreventifService: EntretienPreventifService,
        private entretienCorrectifService: EntretienCorrectifService,
        private vadService: VadService,
        private bonTravailService: BonTravailService,
        private pieceService: PieceService,
        private liaisonService: LiaisonService,
        private requisitionService: RequisitionService,
        private soumissionService: SoumissionService,
        private contexteService: ContexteService,
        private achatService: AchatService,
        private garantieService: GarantieService,
        private noteService: NoteService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router,
        public datepipe: DatePipe,
        private empruntService: EmpruntService) {
        super(sdb, profilService, route, routerService, appMain);

        this.route.params.subscribe(params => this.itemId = params.id);

        // Get the current user name
        if (this.profilService.ProfilCourant()) {
            this.nomUtilisateur = this.profilService.ProfilCourant().prenom + ' ' + this.profilService.ProfilCourant().nom;
        } else {
            this.nomUtilisateur = 'Utilisateur';
        }
    }

    /* #region  Initialisation */
    ngOnInit() {

        if (this.inputItemId) {
            this.itemId = this.inputItemId;
            this.modeApercu = true;
        }

        this.verifierAccesPage('item_detail');

        this.dateJour.setDate(new Date().getDate() + 1);;

        this.listeCategories = this.sdb.Categories();
        this.listeSousCategoriesComplet = this.sdb.SousCategories();
        this.listeSousCategories = this.sdb.SousCategories();
        this.listeCompagnies = this.sdb.Compagnies();
        this.listeLocalisations = this.sdb.LocalisationsEntrepot();
        this.listeTypesFacturation = this.sdb.TypesFacturation();
        this.listeCategoriesEntretien = this.sdb.CategoriesEntretien();
        this.listeDepartementsMecanique = this.sdb.DepartementsMecanique();

        this.filtresStatut = [];
        this.sdb.Statuts().forEach(x => {
            this.filtresStatut.push(x.nom);
        });

        this.filtresCategorieEntretien = [];
        this.sdb.CategoriesEntretien().forEach(x => {
            this.filtresCategorieEntretien.push(x.description);
        });

        this.ItemsService.ObtenirItem(this.itemId).subscribe(x => {
            this.item = x;
            
            effect(() => {
                if (this.item && this.item.updates()) { 
                    const update = this.item.updates(); 
                    if (update.type == 'update') {
                        this.messageService.add({ severity: 'info', summary: 'Item modifié', detail: "Cet item a été modifié par un autre utilisateur à l'instant"});
                    } 
                }
            }, { injector: this.injector });

            this.breadcrumbService.setItems([
                { label: this.item.value().categorie.categorieId == 6 ? 'Pièces' : this.item.value().indSuiviMecanique ? 'Unités' : 'Items', routerLink: this.item.value().categorie.categorieId == 6 ? '/mecanique/pieces' : this.item.value().indSuiviMecanique ? '/mecanique/unites' : '/items' },
                { label: 'Détails' }
            ]);
            
            this.initialiser();

            this.initialiserMenu();

            this.surSelectionCategorie();

            this.chargerDocuments();


            this.CompleterChargement(`Item - ${this.item.value().description} (${this.item.value().numero})`);

            if (this.contexteService.ValiderPresence(["messageInitItem"])) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: this.contexteService.Obtenir("messageInitItem") });
                this.contexteService.Supprimer("messageInitItem");
            }

            if (this.contexteService.ValiderPresence(["tab"])) {
                this.tabIndex.set(parseInt(this.contexteService.Obtenir("tab")));
                this.contexteService.Supprimer("tab");
            } else {

                this.route.queryParams.subscribe(params => {
                    if (!params['tab']) {
                        if (this.profilService.Profil().roles.filter(x => x.nom == 'SIHC_ContremaitreMecanique').length > 0 && this.item.value().indSuiviMecanique) {
                            this.tabIndex.set(7);
                        }
                    }
                });

            }

            if (this.contexteService.ValiderPresence(["tabentretien"])) {
                this.tabIndexEntretiens = Number(this.contexteService.Obtenir("tabentretien"));
                this.contexteService.Supprimer("tabentretien");

                setTimeout(() => {
                    this.gererChangementOngletEntretiens(this.tabIndexEntretiens);
                }, 750);
            } 
        });



        this.ItemsService.ObtenirAttributsItem(this.itemId).then(x => {
            this.attributs = x.valeur;
            this.nbAttributsRenseignes = this.attributs.filter(x => x.valeur).length;
            this.nbAttributsTotal = this.attributs.length;


            this.chargementCompleteAttributs = true;
        });





    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.gererChangementOnglet(this.tabIndex(), this);
        }, 1000);
    }

    rafraichir() {
        this.contexteService.Ajouter("tab", this.tabIndex().toString());
        this.contexteService.Ajouter("tabentretien", this.tabIndexEntretiens.toString());
        this.naviguer(`item/${this.item.value().itemId}`)
    }

    /* GÉNÉRAL */

    initialiser() {
        if (this.item.value().departementMecanique) {
            this.item.value().departementMecanique = this.listeDepartementsMecanique.find(x => x.departementMecaniqueId == this.item.value().departementMecanique.departementMecaniqueId);
        }
    }

    initialiserMenu() {
        this.menu = [
            {
                label: 'Retour', icon: 'pi pi-fw pi-angle-double-left', command: () => this.goBack()
            },
            {
                label: 'Imprimer', icon: 'pi pi-fw pi-print', command: () => this.afficherImpression()
            },
            {
                label: 'Actions', icon: 'pi pi-fw pi-bars',
                items: this.ItemsService.getItemActions(this.item.value(), this.attributs)
            },
        ];
    }

    goBack() {
        window.history.back();
        setTimeout(() => {
          this.ngOnInit();
        }, 100);
      }

    surChangementOnglet(event) {
        this.gererChangementOnglet(event.index, this);
    }


    async gererChangementOnglet(index: number, self: DetailItemComponent) {

        if (index === undefined) return;

        while (!self.tabView) {
            await new Promise(resolve => setTimeout(resolve, 100));
        }

        if (self.tabView.tabs[index]._header.startsWith('Inventaire') && !self.chargementCompleteInventaire) {
            self.ItemsService.ObtenirInventaireItem(self.itemId).then(x => {
                self.item.value().inventaire = x.valeur;

                self.chargementCompleteInventaire = true;
            });
        }
        if (self.tabView.tabs[index]._header.startsWith('Historique') && !self.chargementCompleteHistorique) {
            self.ItemsService.ObtenirHistoriqueItem(self.itemId).then(x => {
                self.item.value().historique = x.valeur;
                self.historiqueFiltre = [...x.valeur];

                self.chargementCompleteHistorique = true;
            });
        }
        if (self.tabView.tabs[index]._header.startsWith('Heures') && !self.chargementCompleteRelevesHeure) {

            var p1 = new Promise<number>((resolve, reject) => {
                self.heureService.ObtenirListeParItem(self.itemId).then(x => {
                    self.item.value().relevesHeure = x.valeur;
                    resolve(null);
                });
            });

            var p2 = new Promise<number>((resolve, reject) => {
                self.kmService.ObtenirListeParItem(self.itemId).then(x => {
                    self.item.value().relevesKm = x.valeur;
                    resolve(null);
                });
            });



            Promise.all([p1, p2]).then(x => {
                self.chargementCompleteRelevesHeure = true;
            });


        }

        if (self.tabView.tabs[index]._header.startsWith('Fournisseurs') && !self.chargementCompletePrixFournisseurs) {
            self.fournisseurService.ObtenirListePrixPourItem(self.itemId).then(res => {
                if (res.estUnSucces) {
                    self.item.value().fournisseurs = res.valeur;
                    self.chargementCompletePrixFournisseurs = true;
                }
            });
        }

        if (self.tabView.tabs[index]._header.startsWith('Achats') && !self.chargementCompleteAchats) {
            self.achatService.ObtenirHistoriqueItem(self.itemId).then(res => {
                if (res.estUnSucces) {
                    self.item.value().achats = res.valeur;
                    self.chargementCompleteAchats = true;
                }
            });
        }

        if (self.tabView.tabs[index]._header.startsWith('Soumissions') && !self.chargementCompleteSoumissions) {
            self.soumissionService.ObtenirSoumissionsParItem(self.itemId).then(res => {
                if (res.estUnSucces) {
                    self.item.value().soumissions = res.valeur;
                    self.chargementCompleteSoumissions = true;
                }
            });
        }

        if (self.tabView.tabs[index]._header.startsWith('Associations') && !self.chargementCompleteAssociations) {
            self.pieceService.ObtenirParPiece(self.itemId).then(res => {
                if (res.estUnSucces) {
                    self.item.value().associations = res.valeur;
                    self.chargementCompleteAssociations = true;
                }
            });
        }

        if (self.tabView.tabs[index]._header.startsWith('Documents liés') && !self.chargementCompleteDocumentsLies) {
            self.documentService.ObtenirListeItemLies({
                id: self.item.value().itemId
            }).then(x => {
                self.item.value().documentslies = x.valeur;

                self.chargementCompleteDocumentsLies = true;
            });
        }

        if (self.tabView.tabs[index]._header.startsWith('Liaisons') && !self.chargementCompleteLiaisons) {
            self.ItemsService.ObtenirLiaisonsItem(self.itemId).subscribe(x => {
                self.item.value().liaisons = x.valeur;
                self.construireLiaisonsOrgChart();
                self.chargementCompleteLiaisons = true;
            });
        }
        if (self.tabView.tabs[index]._header.startsWith('Garanties') && !self.chargementCompleteGaranties) {

            self.typesGarantie = self.sdb.TypesGarantie();

            self.garantieService.ObtenirListeParItem(self.itemId).then(x => {
                self.item.value().garanties = x.valeur;

                self.chargementCompleteGaranties = true;
            });
        }
        if (self.tabView.tabs[index]._header.startsWith('Notes') && !self.chargementCompleteNotes) {
            self.ItemsService.ObtenirNotesItem(this.itemId).then(x => {
                self.item.value().notes = x.valeur;

                self.chargementCompleteNotes = true;
            });
        }

        if (self.tabView.tabs[index]._header.startsWith('Entretien') && !self.chargementCompleteEntretiens) {
            self.chargementCompleteEntretiens = true;

            self.bonTravailService.ObtenirParItem(self.item.value().itemId).then(x => {
                self.item.value().bonsTravail = enrichirPrenomNomBonTravails(x.valeur);
                self.chargementCompleteBonsTravail = true;
                self.nbBdtEnCours = self.item.value().bonsTravail.filter(bdt => 
                    bdt.statut.statutId != EStatuts.Complete && !bdt.indSoumission).length;
                self.nbSoumissionsEnCours = self.item.value().bonsTravail.filter(bdt => 
                    bdt.statut.statutId != EStatuts.Complete && bdt.indSoumission).length;
            });
            
            setTimeout(() => {
                self.gererChangementOngletEntretiens(self.tabIndexEntretiens);
            }, 750);

        }
    }

    /* #endregion */

    CreerItemRetour(item: ItemMin, retour: RequisitionMin) {

        this.Bloquer();

        this.requisitionService.CreerItemRequisition({
            itemsRequisition: [{
                itemRequisitionId: 0,
                requisitionId: retour.requisitionId,
                item: item,
                statut: this.sdb.Statut(EStatuts.Actif),
                employe: this.profilService.ProfilCourant(),
                quantite: 1,
                expediteur: null,
                demandeur: null
            }]
        })

        item.emplacement = this.sdb.Emplacement(10000);

        this.Debloquer();

        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Retour effectué.' });
    }

    ouvrirItemLie() {
        this.routerService.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.routerService.navigate(['item/' + this.item.value().parentId]));
    }



    ouvrirFicheComplete() {
        this.routerService.navigateByUrl('item/' + this.itemId);
    }

    SupprimerRequisition(req: ItemMin) {
        this.confirmationService.confirm({
            message: `Voulez-vous vraiment archiver l'item #${req.numero}`,
            accept: () => {
                this.messageService.add({ severity: 'info', summary: 'Suppression complétée', detail: `Item #${req.numero} supprimé` });
            }
        });
    }



    ajustementInventaire(inventaire: Inventaire) {

        const ref = this.dialogService.open(AjustementInventaireComponent, {
            data: {
                itemId: this.item.value().itemId,
                emplacementId: inventaire.emplacement.emplacementId,
                numero: this.item.value().numero,
                description: this.item.value().description,
                emplacement: inventaire.emplacement,
                quantiteCourante: inventaire.quantite // TODO : donner la responsabilité au composant d'ajustement d'aller chercher l'info sur l'inventaire courant
            },
            header: 'Ajustement d\'inventaire',
            width: '50%'
        }).onClose.subscribe((res: ResultatAjustementInventaire) => {
            if (res) {
                inventaire.quantite = res.nouvelleQuantite;
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `L'inventaire a été ajusté.` });
            }
        });
    }


    commander(item: Item, fournisseur: Fournisseur, numeroFournisseur: string, prix: number) {
        const ref = this.dialogService.open(CreationCommandeComponent, {
            data: {
                itemId: item.itemId,
                numeroItem: item.numero,
                descriptionItem: item.description,
                fournisseurId: fournisseur.fournisseurId,
                nomFournisseur: fournisseur.nom,
                numeroFournisseur: fournisseur.numero,
                numeroItemFournisseur: numeroFournisseur,
                prix: prix
            },
            header: 'Création d\'un bon de commande',
            width: '60%'
        }).onClose.subscribe((res: ResultatCreationBonCommande) => {
            if (res) {
                if (res.redirection) {
                    this.routerService.navigateByUrl('achat/' + res.bonCommandeId);
                } else {
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'item a été ajouté au bon de commande.' });
                }
            }


        });
    }

    /* #endregion */

    /* #region  Modification */

    btnModifier_click() {
        this.modifierAttributs();
        this.Modifier();
    }

    annulerModification() {
        this.DemarrerChargement();
        this.annulerAttributs();

        this.ItemsService.ObtenirItem(this.itemId).subscribe(x => {
            this.item.value().description = x.value().description;
            this.item.value().categorie = x.value().categorie;
            this.item.value().sousCategorie = x.value().sousCategorie;
            this.item.value().marque = x.value().marque;
            this.item.value().modele = x.value().modele;
            this.CompleterChargement();
        });

        this.Consulter();
    }

    submitted = false;

    enregistrerModifications() {
        this.submitted = true;
        this.messageService.clear();

        if (this.validerModificationItem()) {
            this.DemarrerChargement();
            this.ItemsService.ModifierItem(this.item.value()).then(x => {
                this.chargementCompleteBonsTravail = false;
                this.chargementCompleteGaranties = false;
                this.chargementCompleteHistorique = false;
        this.historiqueFiltre = [];
                this.chargementCompletePieces = false;
                this.chargementCompleteRelevesHeure = false;
                this.chargementCompleteEntretiensPreventifs = false;
                this.chargementCompleteEntretiensCorrectifs = false;
                this.chargementCompleteInventaire = false;
                this.chargementCompleteSoumissions = false;
                this.chargementCompleteAssociations = false;
                this.chargementCompleteDocuments = false;
                this.chargementCompleteAchats = false;
                this.chargementCompleteDocumentsLies = false;
                this.chargementCompleteEntretiens = false;
                this.chargementCompleteHistoriquePieces = false;
                this.chargementCompleteHistoriqueAchatPieces = false;
                this.chargementCompleteLiaisons = false;
                this.chargementCompleteNotes = false;
                this.chargementCompletePrixFournisseurs = false;
                this.chargementCompleteVad = false;

                this.initialiser();

                this.initialiserMenu();
    
                this.surSelectionCategorie();

                this.chargerDocuments();
                
                this.CompleterChargement();
                if (x.estUnSucces) {
                    this.Consulter();
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Item modifié.' });
                } else {
                    x.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
                    });

                }

            });

            this.enregistrerAttributs();
        }
    }

    validerModificationItem(): boolean {

        if (!this.item.value().categorie) {
            return false;
        }

        if (this.item.value().categorie.estUnique &&
            (!this.item.value().numero || !this.item.value().description)) {
            return false;
        }

        return true;
    }

    surSelectionCategorie() {
        this.listeSousCategories = this.listeSousCategoriesComplet.filter(x => x.categorieId == this.item.value().categorie.categorieId);
    }

    surSuiviHeures() {
        this.item.value().indIgnorerRapportHeures = !this.item.value().indSuiviHeures;
    }

    surSuiviKms() {
        this.item.value().indIgnorerRapportKms = !this.item.value().indSuiviKms;
    }   

    /* #endregion */

    /* #region  Rapports */


    afficherImpression() {
        if (this.item.value().categorie.estUnique) {
            this.optionsImpression.inventaire = false;
            this.optionsImpression.fournisseurs = false;
            this.optionsImpression.achats = false;
        } else {
            this.optionsImpression.liaisons = false;
            this.optionsImpression.garanties = false;
        }
        this.dialogueImpression = true;

    }

    imprimer() {
        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée.` });
        this.dialogueImpression = false;

        this.rapportService.ProduireRapportItem({
            itemId: this.item.value().itemId,
            options: this.optionsImpression
        }).then(x => {
            if (x) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Votre rapport a été généré.` });
            } else {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue pendant la génération de votre rapport.` });
            }
        });
    }

    selectionnerTout() {
        this.optionsImpression.historique = true;
        this.optionsImpression.notes = true;

        if (this.item.value().categorie.estUnique) {
            this.optionsImpression.liaisons = true;
            this.optionsImpression.garanties = true;
        } else {
            this.optionsImpression.inventaire = true;
            this.optionsImpression.fournisseurs = true;
            this.optionsImpression.achats = true;
        }
    }

    deselectionnerTout() {
        this.optionsImpression.historique = false;
        this.optionsImpression.inventaire = false;
        this.optionsImpression.liaisons = false;
        this.optionsImpression.achats = false;
        this.optionsImpression.fournisseurs = false;
        this.optionsImpression.garanties = false;
        this.optionsImpression.notes = false;

    }

    annulerImpression() {
        this.dialogueImpression = false;
    }

    /* #endregion */

    /* #region  Attributs */

    modifierAttributs() {
        this.attributs.forEach(x => {
            if (x.attribut.typeChamp == ETypeChampAttribut.Booleen) {
                x.valeurFrontend = x.valeur ? x.valeur === 'true' : null;
            }
            else if (x.attribut.typeChamp == ETypeChampAttribut.Date) {
                x.valeurFrontend = x.valeur ? new Date(x.valeur) : null;
            }
            else if (x.attribut.typeChamp == ETypeChampAttribut.Decimales) {
                x.valeurFrontend = x.valeur ? parseFloat(x.valeur) : null;
            }
            else if (x.attribut.typeChamp == ETypeChampAttribut.Numerique) {
                x.valeurFrontend = x.valeur ? parseInt(x.valeur) : null;
            }
            else if (x.attribut.typeChamp == ETypeChampAttribut.Texte) {
                x.valeurFrontend = x.valeur;
            }
            else {
                x.valeurFrontend = x.valeur;
            }
        });

    }

    enregistrerAttributs() {

        this.chargementCompleteAttributs = false;

        this.attributs.forEach(x => {
            if (x.valeurFrontend !== undefined && x.valeurFrontend !== null) {
                x.valeur = x.valeurFrontend.toString();
            } else {
                x.valeur = null;
            }
        });

        this.ItemsService.ModifierAttributsItem(this.item.value().itemId, this.attributs).then(res => {
            if (res.estUnSucces) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Attribut modifiés.` });
                this.chargementCompleteAttributs = true;
            } else {
                res.messages.forEach(x => {
                    this.messageService.add({ severity: 'error', summary: 'Erreur lors de la modification des attributs', detail: x.description });
                });
            }


        });

    }

    annulerAttributs() {
        this.chargementCompleteAttributs = false;

        this.ItemsService.ObtenirAttributsItem(this.item.value().itemId).then(x => {
            this.attributs = x.valeur;
            this.chargementCompleteAttributs = true;
        });
    }

    /* #endregion */

    /* #region  Inventaire */


    surMenuContextuelInventaire(event, inventaire: Inventaire) {
        this.selectionInventaire = inventaire;

        this.contenuMenuContextuelInventaire = [
            {
                label: 'Voir l\'emplacement',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('emplacement_detail'),
                command: () => this.routerService.navigateByUrl('emplacement/' + this.selectionInventaire.emplacement.emplacementId)
            },
            { separator: true, visible: this.estAutorise('item_ajuster_inventaire') },
            {
                label: 'Ajuster l\'inventaire',
                icon: 'pi pi-fw pi-sliders-h',
                visible: this.estAutorise('item_ajuster_inventaire'),
                command: () => this.ajustementInventaire(inventaire)
            },
        ];

        this.menuContextuelInventaire.toggle(event);
    }

    /* #endregion */

    /* #region  Historique */

    filtrerHistorique(terme: string): void {
        if (!this.item.value()?.historique) {
            this.historiqueFiltre = [];
            return;
        }
        
        if (!terme || terme.trim() === '') {
            this.historiqueFiltre = [...this.item.value().historique];
            return;
        }
        
        const termeRecherche = terme.toLowerCase().trim();
        this.historiqueFiltre = this.item.value().historique.filter(historique => {
            // Search in requisition properties if present
            if (historique.requisition) {
                const numero = historique.requisition.numero?.toString().toLowerCase() || '';
                const typeNom = historique.requisition.type?.nom?.toLowerCase() || '';
                const deNom = historique.requisition.de?.nom?.toLowerCase() || '';
                const deCode = historique.requisition.de?.code?.toLowerCase() || '';
                const aNom = historique.requisition.a?.nom?.toLowerCase() || '';
                const aCode = historique.requisition.a?.code?.toLowerCase() || '';
                const demandeur = historique.requisition.demandeur?.nom?.toLowerCase() || '';
                const quantite = historique.quantite?.toString().toLowerCase() || '';
                const empruntePar = historique.emprunt?.employe?.prenom?.toLowerCase() + ' ' + (historique.emprunt?.employe?.nom?.toLowerCase() || '') || '';
                const demandeurEmprunt = historique.emprunt?.employeDemandePar?.nom?.toLowerCase() + ' ' + (historique.emprunt?.employeDemandePar?.prenom?.toLowerCase() || '') || '';
                const emplacementDepartNom = historique.emprunt?.emplacementDepart?.nom?.toLowerCase() || '';
                const emplacementDepartCode = historique.emprunt?.emplacementDepart?.code?.toLowerCase() || '';
                const emplacementRetourNom = historique.emprunt?.emplacementRetour?.nom?.toLowerCase() || '';
                const emplacementRetourCode = historique.emprunt?.emplacementRetour?.code?.toLowerCase() || '';
                
                if (numero.includes(termeRecherche) ||
                    typeNom.includes(termeRecherche) ||
                    deNom.includes(termeRecherche) ||
                    deCode.includes(termeRecherche) ||
                    aNom.includes(termeRecherche) ||
                    aCode.includes(termeRecherche) ||
                    demandeur.includes(termeRecherche) ||
                    quantite.includes(termeRecherche) ||
                    empruntePar.includes(termeRecherche) ||
                    demandeurEmprunt.includes(termeRecherche) ||
                    emplacementDepartNom.includes(termeRecherche) ||
                    emplacementDepartCode.includes(termeRecherche) ||
                    emplacementRetourNom.includes(termeRecherche) ||
                    emplacementRetourCode.includes(termeRecherche)) {
                    return true;
                }
            }

            // Search in emprunt properties if present
            if (historique.emprunt) {
                const empruntId = historique.emprunt.empruntId?.toString().toLowerCase() || '';
                const statutNom = historique.emprunt.statut?.nom?.toLowerCase() || '';
                const employeNom = historique.emprunt.employe?.nom?.toLowerCase() + ' ' + (historique.emprunt.employe?.prenom?.toLowerCase() || '');
                const employeDepartNom = historique.emprunt.employeDepart ? 
                    (historique.emprunt.employeDepart.nom?.toLowerCase() + ' ' + (historique.emprunt.employeDepart.prenom?.toLowerCase() || '')) : '';
                const emplacementDepartNom = historique.emprunt.emplacementDepart?.nom?.toLowerCase() || '';
                const emplacementDepartCode = historique.emprunt.emplacementDepart?.code?.toLowerCase() || '';
                const demandeurNom = historique.emprunt.employeDemandePar ? 
                    (historique.emprunt.employeDemandePar.nom?.toLowerCase() + ' ' + (historique.emprunt.employeDemandePar.prenom?.toLowerCase() || '')) : '';
                const note = historique.emprunt.note?.toLowerCase() || '';

                if (empruntId.includes(termeRecherche) ||
                    statutNom.includes(termeRecherche) ||
                    employeNom.includes(termeRecherche) ||
                    employeDepartNom.includes(termeRecherche) ||
                    emplacementDepartNom.includes(termeRecherche) ||
                    emplacementDepartCode.includes(termeRecherche) ||
                    demandeurNom.includes(termeRecherche) ||
                    note.includes(termeRecherche)) {
                    return true;
                }
            }

            return false;
        });
    }

    surMenuContextuelHistorique(event, historique: HistoriqueItem) {
        this.selectionHistorique = historique;

        this.contenuMenuContextuelHistorique = [];

        // Add requisition menu item if it's a requisition
        if (historique.requisition) {
            this.contenuMenuContextuelHistorique.push({
                label: 'Voir la réquisition',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('requisition_detail'),
                command: () => this.routerService.navigateByUrl('transport/' + this.selectionHistorique.requisition.requisitionId)
            });
        }

        // Add emprunt menu item if it's an emprunt
        if (historique.emprunt) {
            this.contenuMenuContextuelHistorique.push({
                label: 'Voir l\'emprunt',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('emprunt'),
                command: () => this.routerService.navigateByUrl('emprunt/' + this.selectionHistorique.emprunt.empruntId)
            });
        }

        this.menuContextuelHistorique.toggle(event);
    }

    /* #endregion */

    /* #region  Heures */


    surMenuContextuelReleveHeure(event, releveHeure: ReleveHeureEntite) {
        this.selectionReleveHeure = releveHeure;

        this.contenuMenuContextuelReleveHeure = [
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-trash',
                visible: this.estAutorise('item_heure_modifier'),
                command: _ => this.supprimerReleveHeure(releveHeure)
            }
        ];

        this.menuContextuelReleveHeure.toggle(event);
    }

    supprimerReleveHeure(releveHeure: ReleveHeureEntite) {
        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment supprimer les heures sélectionnées ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.heureService.SupprimerHeures(releveHeure.releveHeureId).then(res => {
                    if (res.estUnSucces) {
                        this.contexteService.Ajouter("messageInitItem", 'Heures supprimées..');
                        this.rafraichir();
                        // this.item.relevesHeure = this.item.relevesHeure.filter(val => val.releveHeureId != releveHeure.releveHeureId);
                        // this.chargementCompleteEntretiensPreventifs = false;
                        // this.tabIndexEntretiens = 0;
                        // this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'HEures supprimées.' });

                        // this.contexteService.Ajouter("tab", "2");
                        // this.naviguer(`item/${this.item.itemId}`)
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    // ajouterReleveHeure() {
    //     const ref = this.dialogService.open(AjoutReleveHeureComponent, {
    //         data: {
    //             item: this.ItemsService.ItemVersItemMin(this.item)
    //         },
    //         header: 'Ajout d\'un relevé d\'heures',
    //         width: '50%'
    //     }).onClose.subscribe((res: ReleveHeureEntite) => {
    //         if (res) {
    //             this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Relevé d\'heures ajouté' });
    //             this.item.relevesHeure.unshift(res);
    //         }
    //     });
    // }

    surMenuContextuelReleveKm(event, releveKm: ReleveKmEntite) {
        this.selectionReleveKm = releveKm;

        this.contenuMenuContextuelReleveKm = [
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-trash',
                visible: this.estAutorise('item_heure_modifier'),
                command: _ => this.supprimerReleveKm(releveKm)

            }
        ];

        this.menuContextuelReleveKm.toggle(event);
    }

    supprimerReleveKm(releveKm: ReleveKmEntite) {
        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment supprimer les km sélectionnés ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.kmService.SupprimerKms(releveKm.releveKmId).then(res => {
                    if (res.estUnSucces) {
                        this.contexteService.Ajouter("messageInitItem", 'KM supprimés.');
                        this.rafraichir();
                        // this.item.relevesKm = this.item.relevesKm.filter(val => val.releveKmId != releveKm.releveKmId);
                        // this.chargementCompleteEntretiensPreventifs = false;
                        // this.tabIndexEntretiens = 0;
                        // this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Kms supprimés.' });
                        
                        // this.contexteService.Ajouter("tab", "2");
                        // this.naviguer(`item/${this.item.itemId}`)
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    // ajouterReleveKm() {
    //     const ref = this.dialogService.open(AjoutReleveKmComponent, {
    //         data: {
    //             item: this.ItemsService.ItemVersItemMin(this.item)
    //         },
    //         header: 'Ajout d\'un relevé de KM',
    //         width: '50%'
    //     }).onClose.subscribe((res: ReleveHeureEntite) => {
    //         if (res) {
    //             this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Relevé de KM ajouté' });
    //             this.item.relevesKm.unshift(res);
    //         }
    //     });
    // }

    ouvrirAjustements() {
        const ref = this.dialogService.open(AjustementsComponent, {
            data: {
                itemId: this.item.value().itemId
            },
            header: 'Ajustements de compteur',
            width: '50%'
        });
    }

    ouvrirAjustementsKm() {
        const ref = this.dialogService.open(AjustementsKmComponent, {
            data: {
                itemId: this.item.value().itemId
            },
            header: 'Ajustements de compteur',
            width: '50%'
        });
    }

    ajouterHeuresApprouvee() {
        const ref = this.dialogService.open(AjouterHeureComponent, {
            data: {
                item: this.item.value(),
                ignorerApprobation: true
            },
            header: 'Ajout d\'heures (sans approbation)',
            width: '50%'
        }).onClose.subscribe((res: any) => {
            if (res) {
                
                this.contexteService.Ajouter("messageInitItem", 'Heures ajoutées.');
                this.rafraichir();

                

                // this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Heures ajoutées.' });
                // this.chargementCompleteEntretiensPreventifs = false;
                // this.tabIndexEntretiens = 0;
                // this.Bloquer();
                // this.ItemsService.ObtenirItem(this.item.itemId).then(x => {
                //     this.item.heuresCompteur = x.valeur.heuresCompteur;
                //     this.item.heuresReelles = x.valeur.heuresReelles;
                //     this.item.dateHeures = x.valeur.dateHeures;
                //     this.Debloquer();
                // })
            }


        });
    }

    ajouterKmsApprouvee() {
        const ref = this.dialogService.open(AjouterKmComponent, {
            data: {
                item: this.item.value(),
                ignorerApprobation: true
            },
            header: 'Ajout de KM (sans approbation)',
            width: '50%'
        }).onClose.subscribe((res: any) => {
            if (res) {
                
                this.contexteService.Ajouter("messageInitItem", 'KM ajoutés.');
                this.rafraichir();
                // this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'KM ajoutés.' });
                // this.chargementCompleteEntretiensPreventifs = false;
                // this.tabIndexEntretiens = 0;
                // this.Bloquer();
                // this.ItemsService.ObtenirItem(this.item.itemId).then(x => {
                //     this.item.kmCompteur = x.valeur.kmCompteur;
                //     this.item.kmReel = x.valeur.kmReel;
                //     this.item.dateKm = x.valeur.dateKm;
                //     this.Debloquer();
                // });
            }


        });
    }

    /* #endregion */

    /* #region  Documents */

    chargerDocuments() {
        this.documentService.ObtenirListeDocuments(ETypeLien.Item, this.item.value().itemId).subscribe({
            next: res => {
                if (res.body) {
                    this.documentsComplet = res.body.documents;
                    this.chargementCompleteDocuments = true;

                    var photoPrincipale = this.documentsComplet.find(x => x.indPrincipale);
                    if (photoPrincipale) {
                        this.photoPrincipale = photoPrincipale;
                        this.loadPreviewImage(photoPrincipale);
                    }
                }
            },
            error: () => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors de la récupération des informations des documents.' });
            }
        });
    }

    loadPreviewImage(doc: DocumentEntite) {
        if (!doc.previewUrl) {
            if (doc.indCloudflare) {
                this.documentService.ObtenirApercuCloudflare(doc.cheminFichier).subscribe({
                    next: res => {
                        if (res.type === HttpEventType.Response) {
                            doc.previewUrl = URL.createObjectURL(res.body);
                        }
                    }
                });
            }
        } 
    }

    get ETypeLienDocument() {
        return ETypeLien;
    }

    /* #endregion */

    /* #region  Fournisseurs */


    surMenuContextuelFournisseur(event, prixFournisseur: PrixFournisseurEntite) {
        this.selectionPrixFournisseur = prixFournisseur;

        this.contenuMenuContextuelFournisseur = [
            {
                label: 'Voir le fournisseur',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('fournisseur_detail'),
                command: () => this.routerService.navigateByUrl('fournisseur/' + this.selectionPrixFournisseur.fournisseur.fournisseurId)
            },
            { separator: true, visible: this.estAutorise('bdc_creer') },
            {
                label: 'Modifier', icon: 'pi pi-fw pi-pencil',
                visible: this.estAutorise('bdc_creer') && !this.modeApercu,
                command: () => this.modifierPrixFournisseur(prixFournisseur)
            },
            { separator: true },
            {
                label: 'Supprimer', icon: 'pi pi-fw pi-times',
                visible: this.estAutorise('bdc_creer') && !this.modeApercu,
                command: () => this.supprimerPrixFournisseur(prixFournisseur)
            },
            { separator: true },
            {
                label: 'Commander',
                icon: 'pi pi-fw pi-shopping-cart',
                visible: this.estAutorise('bdc_creer'),
                command: () => this.commander(this.item.value(), this.selectionPrixFournisseur.fournisseur, this.selectionPrixFournisseur.numeroFournisseur, this.selectionPrixFournisseur.prix),
            }
        ];

        this.menuContextuelFournisseur.toggle(event);
    }

    AjouterFournisseur() {
        const ref = this.dialogService.open(AjoutFournisseurPieceComponent, {
            data: {
                item: this.item.value()
            },
            header: 'Ajout d\'un fournisseur',
            width: '50%'
        }).onClose.subscribe((res: PrixFournisseurEntite) => {
            if (res) {
                this.chargementCompletePrixFournisseurs = false;
                this.fournisseurService.ObtenirListePrixPourItem(this.itemId).then(res => {
                    if (res.estUnSucces) {
                        this.item.value().fournisseurs = res.valeur;
                        this.chargementCompletePrixFournisseurs = true;
                        this.messageService.add({ key: 'selectionItem', severity: 'success', summary: 'Succès', detail: 'Fournisseur ajouté' });
                        this.item.value().  nbEntreesFournisseurs++;
                    }
                });

            }
        });
    }

    modifierPrixFournisseur(prixFournisseur: PrixFournisseurEntite) {
        const ref = this.dialogService.open(ModifierFournisseurPieceComponent, {
            data: prixFournisseur,
            header: 'Modifier un fournisseur',
            width: '50%'
        }).onClose.subscribe((res: PrixFournisseurEntite) => {
            if (res) {
                this.chargementCompletePrixFournisseurs = false;
                this.fournisseurService.ObtenirListePrixPourItem(this.itemId).then(res => {
                    if (res.estUnSucces) {
                        this.item.value().fournisseurs = res.valeur;
                        this.chargementCompletePrixFournisseurs = true;
                        this.messageService.add({ key: 'selectionItem', severity: 'success', summary: 'Succès', detail: 'Prix modifié' });
                        this.item.value().nbEntreesFournisseurs++;
                    }
                });

            }
        });
    }

    supprimerPrixFournisseur(prixFournisseur: PrixFournisseurEntite) {
        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment supprimer prix fournisseur ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.fournisseurService.SupprimerPrixFournisseur(prixFournisseur.prixFournisseurId).then(res => {
                    if (res.estUnSucces) {
                        this.item.value().fournisseurs = this.item.value().fournisseurs.filter(x => x.prixFournisseurId != prixFournisseur.prixFournisseurId);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Prix supprimé.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });
    }

    /* #endregion */

    /* #region  Achats */

    OuvrirDetailBdcNouvelOnglet(itemId: number) {
        this.detailBdcId = itemId;
        this.afficherDetailBdc = true;
    }
    
    surMenuContextuelAchat(event, itemBonCommande: ItemBonCommande) {
        this.selectionAchat = itemBonCommande;

        this.contenuMenuContextuelAchat = [
            {
                label: 'Voir le bon de commande',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('bdc_detail'),
                command: () => this.routerService.navigateByUrl('achat/' + this.selectionAchat.bonCommande.bonCommandeId)
            },
            {
                label: 'Voir le fournisseur',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('fournisseur_detail'),
                command: () => this.routerService.navigateByUrl('fournisseur/' + this.selectionAchat.bonCommande.fournisseur.fournisseurId)
            },
            { separator: true },
            {
                label: 'Commander',
                icon: 'pi pi-fw pi-shopping-cart',
                visible: this.estAutorise('bdc_creer'),
                command: () => this.commander(this.item.value(), this.selectionAchat.bonCommande.fournisseur, this.selectionAchat.noFournisseur, this.selectionAchat.prix)
            }
        ];

        this.menuContextuelAchat.toggle(event);
    }

    analyserItem() {
        const ref = this.dialogService.open(AnalyseItemComponent, {
            data: {
                "itemId": this.item.value().itemId
            },
            header: 'Analyse du prix',
            width: '50%'
        });
    }

    /* #endregion */

    /* #region  Soumissions */


    surMenuContextuelSoumission(event, soumission: SoumissionEntite) {
        this.selectionSoumissions = soumission;

        this.contenuMenuContextuelSoumissions = [
            {
                label: 'Voir la soumission',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('soumission_detail'),
                command: () => this.routerService.navigateByUrl('soumission/' + this.selectionSoumissions.soumissionId)
            },
            {
                label: 'Voir le fournisseur',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('fournisseur_detail'),
                command: () => this.routerService.navigateByUrl('fournisseur/' + this.selectionSoumissions.fournisseur.fournisseurId)
            }
        ];

        this.menuContextuelSoumissions.toggle(event);
    }

    /* #endregion */

    /* #region  Associations */

    ajouterAssociation() {


        const ref = this.dialogService.open(SelectionCategorieEntretienComponent, {
            data: {
                obligatoire: false
            },
            header: 'Associations',
            width: '50%'
        }).onClose.subscribe((resSelectionCategorie: CategorieEntretienEntite) => {
            if (resSelectionCategorie) {

                const ref2 = this.dialogService.open(SelectionMutipleUniteMecaniqueComponent, {
                    data: {

                    },
                    header: 'Associations',
                    width: '70%'
                }).onClose.subscribe((res: ItemMin[]) => {
                    if (res) {

                        var piecesUnites: PieceUniteEntite[] = [];

                        res.forEach(item => {
                            piecesUnites.push({
                                unite: item,
                                piece: this.ItemsService.ItemVersItemMin(this.item.value()),
                                categorieEntretien: resSelectionCategorie.categorieEntretienId != 0 ? resSelectionCategorie : null
                            });
                        });

                        this.Bloquer();

                        this.pieceService.Creer(piecesUnites).then(resCreerPU => {

                            this.Debloquer();
                            if (resCreerPU.estUnSucces) {
                                resCreerPU.valeur.forEach(pu => {
                                    if (pu.pieceUniteId) {
                                        this.item.value().associations.push(pu);
                                    }
                                });
                                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Associations ajoutées' });
                            } else {
                                resCreerPU.messages.forEach(x => {
                                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                                });
                            }
                        });
                    }
                });

            }
        });


    }

    surMenuContextuelAssociation(event, pieceUnite: PieceUniteEntite) {
        this.contenuMenuContextuelAssociation = [
            {
                label: 'Voir l\'unité',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('item_detail'),
                command: () => this.routerService.navigateByUrl('/', { skipLocationChange: true }).then(() => this.routerService.navigate(['item/' + pieceUnite.unite.itemId]))
            },
            {
                label: 'Voir l\'historique de pose',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('temp_mec')
            },
            { separator: true },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-trash',
                visible: this.estAutorise('temp_mec') || this.estAutorise('piece_associer'),
                command: () => this.supprimerAssociation(pieceUnite)
            },
        ];

        this.menuContextuelAssociation.toggle(event);
    }

    supprimerAssociation(piece: PieceUniteEntite) {

        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment supprimer la pièce sélectionnée ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.Bloquer();
                this.pieceService.Supprimer(piece.pieceUniteId).then(res => {
                    this.Debloquer();
                    if (res.estUnSucces) {
                        this.item.value().associations = this.item.value().associations.filter(val => val.pieceUniteId != piece.pieceUniteId);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'association supprimée.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    /* #endregion */

    /* #region  Documents Liés */


    surMenuContextuelDocumentLie(event, liaison: ItemMin) {
        this.selectionLiaison = liaison;

        this.contenuMenuContextuelLiaison = [
            {
                label: 'Voir l\'item',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('item_detail'),
                command: () => this.routerService.navigateByUrl('/', { skipLocationChange: true }).then(() => this.routerService.navigate(['item/' + this.selectionLiaison.itemId]))
            },
            { separator: true },
            {
                label: 'Supprimer la liaison',
                icon: 'pi pi-fw pi-times',
                visible: this.estAutorise('item_liaison_supprimer'),
                command: () => this.supprimerLiaison(liaison)
            }
        ];

        this.menuContextuelLiaison.toggle(event);
    }

    supprimerDocumentLie(liaison: ItemMin) {
        this.confirmationService.confirm({
            message: `Voulez-vous vraiment supprimer la liaison sélectionnée ?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.Bloquer()
                this.liaisonService.Supprimer({
                    itemParent: {
                        itemId: this.item.value().itemId
                    },
                    itemEnfant: {
                        itemId: liaison.itemId
                    }
                }).then(res => {
                    this.Debloquer();
                    if (res.estUnSucces) {

                        this.chargementCompleteLiaisons = false;

                        this.ItemsService.ObtenirLiaisonsItem(this.itemId).subscribe(x => {
                            this.item.value().liaisons = x.valeur;
                            this.construireLiaisonsOrgChart();
                            this.chargementCompleteLiaisons = true;
                        });

                        this.item.value().nbEntreesLiaisons--;
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Liaison supprimée' });

                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    /* #endregion */

    /* #region  Liaisons */

    construireLiaisonsOrgChart() {
        if (!this.item.value().liaisons) {
            this.liaisonsOrgChart = [];
            return;
        }

        // Determine parent node (employee or location)
        let parentNode: any;
        if (this.item.value().employe) {
            parentNode = {
                label: `${this.item.value().employe.prenom} ${this.item.value().employe.nom}`,
                expanded: true,
                data: {
                    name: `${this.item.value().employe.prenom} ${this.item.value().employe.nom}`,
                    title: 'Employé',
                    icon: 'pi pi-user'
                },
                styleClass: 'p-person',
                children: []
            };
        } else if (this.item.value().emplacement) {
            parentNode = {
                label: this.item.value().emplacement.nom,
                expanded: true,
                data: {
                    name: this.item.value().emplacement.nom,
                    title: 'Emplacement',
                    icon: 'pi pi-map-marker'
                },
                styleClass: 'p-person',
                children: []
            };
        } else {
            // No parent, current item becomes root
            parentNode = null;
        }

        // Create current item node
        const currentItemNode = {
            label: `${this.item.value().numero} - ${this.item.value().description}`,
            expanded: true,
            data: {
                name: `${this.item.value().numero}`,
                title: this.item.value().description,
                icon: 'pi pi-box'
            },
            styleClass: 'current-item',
            children: []
        };

        // Create children nodes for liaisons
        if (this.item.value().liaisons.length <= 4) {
            // Display liaisons as individual child nodes
            currentItemNode.children = this.item.value().liaisons.map(liaison => ({
                label: `${liaison.numero} - ${liaison.description}`,
                expanded: true,
                data: {
                    name: liaison.numero,
                    title: liaison.description,
                    icon: 'pi pi-link',
                    liaison: liaison
                },
                styleClass: 'liaison-item'
            }));
        } else {
            // Display liaisons in a dataview within a single child node
            currentItemNode.children = [{
                label: `Relations directes (${this.item.value().liaisons.length})`,
                expanded: true,
                data: {
                    name: 'Relations directes',
                    title: `${this.item.value().liaisons.length} liaisons`,
                    icon: 'pi pi-sitemap',
                    showDataView: true,
                    liaisons: this.item.value().liaisons
                },
                styleClass: 'liaisons-group'
            }];
        }

        // Build final organization chart structure
        if (parentNode) {
            parentNode.children = [currentItemNode];
            this.liaisonsOrgChart = [parentNode];
        } else {
            this.liaisonsOrgChart = [currentItemNode];
        }
    }

    ajouterLiaison() {

        const ref = this.dialogService.open(SelectionItemSimpleComponent, {
            data: {
                choixCategorieDisponible: false,
                categorieIds: [1, 2, 4]
            },
            header: 'Sélection d\'un item',
            width: '95%'
        }).onClose.subscribe((res: ResultatSelectionItemSimple) => {

            if (res) {

                this.Bloquer();

                this.liaisonService.Ajouter({
                    itemParent: {
                        itemId: this.item.value().itemId
                    },
                    itemEnfant: {
                        itemId: res.item.itemId
                    }
                }).subscribe({
                    next: resAjoutLiaison => {
                        this.Debloquer();

                        if (resAjoutLiaison.estUnSucces) {

                            this.item.value().liaisons.push(res.item);

                            this.item.value().nbEntreesLiaisons++;

                            this.messageService.add({ severity: 'success', summary: 'Succès', detail: `La liaison a été ajoutée.` });

                        } else {
                            resAjoutLiaison.messages.forEach(x => {
                                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                            });
                        }
                    },
                    error: err => {
                        this.Debloquer();
                    }
                });
            }
        });


    }

    surMenuContextuelLiaison(event, liaison: ItemMin) {
        this.selectionLiaison = liaison;

        this.contenuMenuContextuelLiaison = [
            {
                label: 'Voir l\'item',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('item_detail'),
                command: () => this.routerService.navigateByUrl('/', { skipLocationChange: true }).then(() => this.routerService.navigate(['item/' + this.selectionLiaison.itemId]))
            },
            { separator: true },
            {
                label: 'Supprimer la liaison',
                icon: 'pi pi-fw pi-times',
                visible: this.estAutorise('item_liaison_supprimer'),
                command: () => this.supprimerLiaison(liaison)
            }
        ];

        this.menuContextuelLiaison.toggle(event);
    }

    supprimerLiaison(liaison: ItemMin) {
        this.confirmationService.confirm({
            message: `Voulez-vous vraiment supprimer la liaison sélectionnée ?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.Bloquer()
                this.liaisonService.Supprimer({
                    itemParent: {
                        itemId: this.item.value().itemId
                    },
                    itemEnfant: {
                        itemId: liaison.itemId
                    }
                }).then(res => {
                    this.Debloquer();
                    if (res.estUnSucces) {

                        this.chargementCompleteLiaisons = false;

                        this.ItemsService.ObtenirLiaisonsItem(this.itemId).subscribe(x => {
                            this.item.value().liaisons = x.valeur;
                            this.construireLiaisonsOrgChart();
                            this.chargementCompleteLiaisons = true;
                        });

                        this.item.value().nbEntreesLiaisons--;
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Liaison supprimée' });

                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    /* #endregion */

    /* #region  Garanties */


    surMenuContextuelGarantie(event, garantie: GarantieEntite) {
        this.garantie = garantie;

        this.contenuMenuContextuelGarantie = [
            {
                label: 'Modifier',
                icon: 'pi pi-fw pi-pencil',
                visible: this.estAutorise('item_garantie_modifier'),
                command: () => this.modifierGarantie(this.garantie)
            },
            { separator: true, visible: this.estAutorise('item_garantie_supprimer') },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-trash',
                visible: this.estAutorise('item_garantie_supprimer'),
                command: () => this.supprimerGarantie(this.garantie)
            },
        ];

        this.menuContextuelGarantie.toggle(event);
    }

    ajouterGarantie() {
        this.garantie = {
            item: {
                itemId: this.item.value().itemId
            },
            statut: this.sdb.Statut(EStatuts.Actif)
        };

        this.grantieSubmitted = false;
        this.dialogueGarantieOuvert = true;
    }

    modifierGarantie(garantie: GarantieEntite) {
        this.garantie = { ...garantie };

        this.garantie.dateDebut = new Date(this.garantie.dateDebut);
        this.garantie.dateFin = new Date(this.garantie.dateFin);

        this.dialogueGarantieOuvert = true;
    }

    supprimerGarantie(garantie: GarantieEntite) {
        this.confirmationService.confirm({
            message: `Voulez-vous vraiment supprimer le garantie sélectionnée ?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.garantieService.Supprimer(garantie.garantieId).then(res => {
                    if (res.estUnSucces) {
                        this.item.value().garanties = this.item.value().garanties.filter(val => val.garantieId !== garantie.garantieId);
                        this.garantie = {};
                        this.item.value().nbEntreesGaranties--;
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Garantie supprimé' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    annulerGarantie() {
        this.dialogueGarantieOuvert = false;
        this.grantieSubmitted = false;
    }

    sauvegarderGarantie() {
        this.grantieSubmitted = true;


        if (!this.valider()) {
            this.messageService.add({ severity: 'error', summary: 'Erreurs', detail: 'Veuillez corriger les erreurs de saisie.' });
            return;
        }

        this.dialogueGarantieBloque = true;

        if (this.garantie.garantieId) {

            this.garantieService.Modifier(this.garantie).then(res => {
                this.dialogueGarantieBloque = false;
                if (res.estUnSucces) {
                    this.garantie = res.valeur;
                    this.item.value().garanties[this.findIndexById(this.garantie.garantieId)] = this.garantie;
                    this.item.value().garanties = [...this.item.value().garanties];
                    this.dialogueGarantieOuvert = false;
                    this.garantie = {};
                    this.item.value().nbEntreesGaranties++;
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Garantie modifié' });
                } else {
                    res.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                    });
                }
            });

        }
        else {

            this.garantieService.Ajouter(this.garantie).then(res => {
                this.dialogueGarantieBloque = false;
                if (res.estUnSucces) {
                    this.garantie = res.valeur;
                    this.item.value().garanties.push(this.garantie);
                    this.item.value().garanties = [...this.item.value().garanties];
                    this.dialogueGarantieOuvert = false;
                    this.garantie = {};
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Garantie ajouté' });
                } else {
                    res.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                    });
                }
            });
        }

    }

    valider() {
        return this.garantie.type && this.garantie.dateDebut && this.garantie.dateFin
    }

    findIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.item.value().garanties.length; i++) {
            if (this.item.value().garanties[i].garantieId === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    selectionnerDelai() {
        const ref = this.dialogService.open(SelectionDelaiComponent, {
            data: {
                dateDebut: this.garantie.dateDebut
            },
            header: 'Sélectionner un délai',
            width: '50%'
        }).onClose.subscribe((res: Date) => {
            if (res) {
                this.garantie.dateFin = new Date(res);
            }

        });
    }

    /* #endregion */

    /* #region  Notes */


    surMenuContextuelNote(event, note: NoteEntite) {
        this.note = note;

        this.contenuMenuContextuelNote = [
            {
                label: 'Modifier',
                icon: 'pi pi-fw pi-pencil',
                visible: this.estAutorise('item_note_modifier'),
                command: () => this.modifierNote(this.note)
            },
            { separator: true },
            {
                label: 'Créer entretien correctif',
                icon: 'pi pi-fw pi-briefcase',
                visible: this.item.value().indSuiviMecanique && (this.estAutorise('entretien_correctif_creer') || this.estAutorise('temp_mec')),
                command: () => this.creerEntretienCorrectifDepuisNote(this.note)
            },
            { separator: true },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-trash',
                visible: this.estAutorise('item_note_supprimer'),
                command: () => this.supprimerNote(this.note)
            },
        ];

        this.menuContextuelNote.toggle(event);
    }

    ajouterNote() {
        this.note = {
            item: {
                itemId: this.item.value().itemId
            },
            date: new Date(),
            employe: this.profilService.ProfilCourant()
        };

        this.noteSubmitted = false;
        this.dialogueNoteOuvert = true;

        setTimeout(() => { this.champNote?.nativeElement?.focus(); }, 100);
    }

    modifierNote(note: NoteEntite) {
        this.note = { ...note };
        this.dialogueNoteOuvert = true;

        setTimeout(() => { this.champNote?.nativeElement?.focus(); }, 100);

    }

    supprimerNote(note: NoteEntite) {
        this.confirmationService.confirm({
            message: `Voulez-vous vraiment supprimer le note sélectionnée ?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.noteService.Supprimer(note.noteId).then(res => {
                    if (res.estUnSucces) {
                        this.item.value().notes = this.item.value().notes.filter(val => val.noteId !== note.noteId);
                        this.note = {};
                        this.item.value().nbEntreesNotes--;
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Note supprimée' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    annulerNote() {
        this.dialogueNoteOuvert = false;
        this.noteSubmitted = false;
    }

    sauvegarderNote() {
        this.noteSubmitted = true;


        if (!this.validerNote()) {
            this.messageService.add({ severity: 'error', summary: 'Erreurs', detail: 'Veuillez corriger les erreurs de saisie.' });
            return;
        }

        this.dialogueNoteBloque = true;

        if (this.note.noteId) {

            this.noteService.Modifier(this.note).then(res => {
                this.dialogueNoteBloque = false;
                if (res.estUnSucces) {
                    this.note = res.valeur;
                    this.item.value().notes[this.findNoteIndexById(this.note.noteId)] = this.note;
                    this.item.value().notes = [...this.item.value().notes];
                    this.dialogueNoteOuvert = false;
                    this.note = {};
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Note modifiée' });
                } else {
                    res.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                    });
                }
            });

        }
        else {

            this.noteService.Ajouter(this.note).then(res => {
                this.dialogueNoteBloque = false;
                if (res.estUnSucces) {
                    this.note = res.valeur;
                    this.item.value().notes.push(this.note);
                    this.item.value().notes = [...this.item.value().notes];
                    this.dialogueNoteOuvert = false;
                    this.note = {};
                    this.item.value().nbEntreesNotes++;
                    this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Note ajoutée' });
                } else {
                    res.messages.forEach(x => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                    });
                }
            });
        }

    }

    validerNote() {
        return this.note.description
    }

    findNoteIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.item.value().notes.length; i++) {
            if (this.item.value().notes[i].noteId === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    /* #endregion */

    /* #region  Bons de travail */


    OuvrirDetailBdt(bonTravailId: number) {
        this.routerService.navigateByUrl(`mecanique/bontravails/${bonTravailId}`);
    }

    OuvrirDetailBdtNouvelOnglet(bonTravailId: number) {
        this.appMain.detailBonTravailId = bonTravailId;
        this.appMain.afficherDetailBonTravail = true;
    }

    AjouterBdt() {
        this.routerService.navigateByUrl("mecanique/soumissions/nouveau/" + this.item.value().itemId);
    }

    get Soumissions() {
        if (this.item.value().bonsTravail) {
            return this.item.value().bonsTravail.filter(bdt => bdt.indSoumission);
        }
        return [];
    }

    get BonsTravail() {
        if (this.item.value().bonsTravail) {
            return this.item.value().bonsTravail.filter(bdt => !bdt.indSoumission);
        }
        return [];
    }

    get BonsTravailOuverts(): BonTravailEntite[] {
        return this.BonsTravail
            .filter(bdt =>
                bdt.statut.statutId === EStatuts.EnCours ||
                bdt.statut.statutId === EStatuts.EnAttente)
            .sort((a, b) => new Date(b.dateCreation).getTime() - new Date(a.dateCreation).getTime());
    }

    /* #endregion */

    /* #region  Entretiens */


    surChangementOngletEntretiens(event) {
        this.gererChangementOngletEntretiens(event.index);
    }

    gererChangementOngletEntretiens(index: number) {

        if (this.tabViewEntretiens.tabs[index]._header.startsWith('Bons de travail') && !this.chargementCompleteBonsTravail) {
        }
        if (this.tabViewEntretiens.tabs[index]._header.startsWith('Préventifs') && !this.chargementCompleteEntretiensPreventifs) {
            this.entretienPreventifService.ObtenirParItem(this.item.value().itemId).then(x => {
                this.item.value().entretiensPreventifs = x.valeur;
                this.afficherHeures = this.item.value().entretiensPreventifs.filter(x => x.indSeuilHeure).length > 0;
                this.afficherKms = this.item.value().entretiensPreventifs.filter(x => x.indSeuilKm).length > 0;
                this.afficherMois = this.item.value().entretiensPreventifs.filter(x => x.indSeuilMois).length > 0;
                this.calculEnCours = this.item.value().entretiensPreventifs.filter(x => x.indCalculEnCours).length > 0;
                this.chargementCompleteEntretiensPreventifs = true;
            });
        }
        if (this.tabViewEntretiens.tabs[index]._header.startsWith('Correctifs') && !this.chargementCompleteEntretiensCorrectifs) {
            this.entretienCorrectifService.ObtenirParItem(this.item.value().itemId).then(x => {
                this.item.value().entretiensCorrectifs = x.valeur;
                
                this.filtrerEntretiensCorrectifs();
                this.chargementCompleteEntretiensCorrectifs = true;
            });
        }
        if (this.tabViewEntretiens.tabs[index]._header.startsWith('Vérification') && !this.chargementCompleteVad) {
            this.vadService.ObtenirVads(this.item.value().itemId).then(x => {
                this.item.value().vads = x.valeur;
                this.chargementCompleteVad = true;
            });
        }

        if (this.tabViewEntretiens.tabs[index]._header.startsWith('Pièces') && !this.chargementCompletePieces) {
            this.pieceService.ObtenirParUnite(this.item.value().itemId).then(x => {
                this.item.value().pieces = x.valeur;
                this.filtrerPieces();
                this.chargementCompletePieces = true;
            });
        }

        if (this.tabViewEntretiens.tabs[index]._header.startsWith('Historique d\'achat') && !this.chargementCompleteHistoriqueAchatPieces) {
            this.achatService.ObtenirHistoriqueAchatPieces(this.item.value().itemId).then(x => {
                this.item.value().historiqueAchatPieces = x.valeur;
                this.chargementCompleteHistoriqueAchatPieces = true;
            });
        }

        if (this.tabViewEntretiens.tabs[index]._header.startsWith('Historique d\'envoi') && !this.chargementCompleteHistoriquePieces) {
            this.ItemsService.ObtenirHistoriquePiecesItem(this.item.value().itemId).then(x => {
                this.item.value().historiquePieces = x.valeur;
                this.chargementCompleteHistoriquePieces = true;
            });
        }
    }

    RecalculerEntreriensPreventifs() {
        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment recalculer tous les entretiens pour l\'item courant ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.Bloquer();
                this.entretienPreventifService.Recalculer(this.item.value().itemId).then(res => {
                    this.Debloquer();
                    if (res.estUnSucces) {
                        this.naviguer(`item/${this.item.value().itemId}`)
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    AjouterEntretienPreventif() {
        this.contexteService.Ajouter("item", JSON.stringify(this.item.value()));
        this.routerService.navigateByUrl('mecanique/entretienpreventif/0');
    }

    surMenuContextuelEntretienPreventif(event, entretien: EntretienPreventifEntite) {
        this.contenuMenuContextuelEntretiensPreventifs = [
            {
                label: 'Voir l\'historique', icon: 'pi pi-fw pi-calendar',
                visible: this.estAutorise('temp_mec') && !entretien.indCalculEnCours,
                command: _ => this.consulterHistoriqueEntretienPreventif(this.item.value(), entretien)
            },
            {
                label: 'Voir les pièces nécessaires', icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('temp_mec') && !entretien.indCalculEnCours,
                command: _ => this.consulterPiecesNecessaires(entretien)
            },
            { separator: true },
            {
                label: 'Détail',
                icon: 'pi pi-fw pi-pencil',
                visible: this.estAutorise('temp_mec') || this.estAutorise('bonstravail') && !entretien.indCalculEnCours,
                command: () => this.detailEntretienPreventif(entretien)
            },
            { separator: true },
            {
                label: 'Voir le bon de travail',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('temp_mec') && entretien.bonTravail != null && entretien.bonTravail != undefined && !entretien.indCalculEnCours,
                command: () => this.routerService.navigateByUrl('mecanique/bontravails/' + entretien.bonTravail.bonTravailId)
            },
            {
                label: 'Créer un bon de travail',
                icon: 'pi pi-fw pi-plus',
                visible: this.estAutorise('temp_mec') && (entretien.bonTravail == null || entretien.bonTravail == undefined) && !entretien.indCalculEnCours,
                command: _ => this.assignerEntretiensPreventifs([entretien])
            },
            { separator: true },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-trash',
                styleClass: 'menuSuppression',
                visible: this.estAutorise('temp_mec'),
                command: _ => this.supprimerEntretienPreventif(entretien)
            },
        ];

        this.menuContextuelEntretiensPreventifs.toggle(event);
    }

    surMenuContextuelEntretiensPreventifs(event) {
        this.contenuMenuContextuelEntretiensPreventifs = [
            {
                label: 'Recalculer les entretiens', icon: 'pi pi-fw pi-refresh',
                visible: this.estAutorise('temp_mec'),
                command: _ => this.RecalculerEntreriensPreventifs()
            },
            {
                label: 'Réactiver un entretien', icon: 'pi pi-fw pi-plus',
                visible: this.estAutorise('temp_mec'),
                command: _ => this.reactiverEntretienPreventif()
            },
            {
                label: 'Imprimer', icon: 'pi pi-fw pi-print',
                visible: this.estAutorise('temp_mec'),
                command: _ => this.ImprimerEntretienPreventif()
            }
        ];

        this.menuContextuelEntretiensPreventifs.toggle(event);
    }

    supprimerEntretienPreventif(entretien: EntretienPreventifEntite) {

        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment supprimer l\'entretien préventif sélectionné. ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.Bloquer();
                this.entretienPreventifService.Supprimer(entretien.entretienPreventifId).then(res => {
                    this.Debloquer();
                    if (res.estUnSucces) {
                        this.item.value().entretiensPreventifs = this.item.value().entretiensPreventifs.filter(val => val.entretienPreventifId != entretien.entretienPreventifId);
                        this.filtrerPieces();
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Entretien supprimé.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    reactiverEntretienPreventif() {

        const ref = this.dialogService.open(SelectionEntretienPreventifComponent, {
            header: 'Réactiver un entretien préventif',
            width: '60%',
            data: this.item.value().itemId
        }).onClose.subscribe((res: EntretienPreventifEntite) => {
            if (res) {

                this.confirmationService.confirm({
                    target: event.target,
                    message: 'Voulez-vous vraiment réactiver l\'entretien préventif sélectionné. ?',
                    header: 'Confirmation',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.Bloquer();
                        this.entretienPreventifService.Reactiver(res.entretienPreventifId).then(res => {
                            this.Debloquer();
                            if (res.estUnSucces) {
                                this.naviguer(`item/${this.item.value().itemId}`)
                            } else {
                                res.messages.forEach(x => {
                                    this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                                });
                            }
                        });
                    }
                });


            }
        });
    }

    ImprimerEntretienPreventif() {
        this.messageService.add({ severity: 'info', summary: 'Demande de rapport', detail: `Votre demande de rapport a été envoyée.` });
        this.dialogueImpression = false;

        this.rapportService.ProduireRapportEntretienPreventif(this.item.value().itemId).then(x => {
            if (x) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Votre rapport a été généré.` });
            } else {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Une erreur est survenue pendant la génération de votre rapport.` });
            }
        });
    }

    detailEntretienPreventif(entretien: EntretienPreventifEntite) {
        this.routerService.navigateByUrl('mecanique/entretienpreventif/' + entretien.entretienPreventifId);
    }

    consulterHistoriqueEntretienPreventif(item: Item, entretien: EntretienPreventifEntite) {
        const ref = this.dialogService.open(HistoriqueEntretienComponent, {
            data: {
                itemId: item.itemId,
                entretienPreventifId: entretien.entretienPreventifId
            },
            header: `Historique d'entretien - ${item.numero} - ${item.description} - ${entretien.description}`,
            width: '75%'
        }).onClose.subscribe(() => {


        });
    }

    assignerEntretiensPreventifs(entretiens: EntretienPreventifEntite[]) {

        const ref = this.dialogService.open(AssignerEntretiensComponent, {
            data: {
                itemId: entretiens[0].item.itemId,
                itemNumero: entretiens[0].item.numero ?? this.item.value().numero,
                entretiensPreventifs: entretiens,
                employeId: this.profilService.ProfilCourant().employeId,
                contreMaitreId: entretiens[0].item.departementMecanique?.contreMaitre?.employeId
            },
            header: `Assigner des entretiens`,
            width: '75%'
        }).onClose.subscribe((bt: BonTravailEntite) => {

            if (bt) {
                this.selectionEntretiensPreventifs = null;

                //TODO
                entretiens.forEach(ent => {
                    ent.statut = this.sdb.Statut(EStatuts.EnCours);
                    ent.bonTravail = bt
                });
    
                this.chargementCompleteBonsTravail = false;
    
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de travail créé.' });

                this.rafraichir();
            }
            

        });

    }

    consulterPiecesNecessaires(entretien: EntretienPreventifEntite) {
        const ref = this.dialogService.open(ConsulterPiecesComponent, {
            header: 'Pièces nécessaires',
            width: '90%',
            data: entretien
        })
    }



    surMenuContextuelEntretienCorrectif(event, entretien: EntretienCorrectifEntite) {
        this.contenuMenuContextuelEntretiensCorrectifs = [
            {
                label: 'Modifier',
                icon: 'pi pi-fw pi-pencil',
                visible: this.estAutorise('temp_mec'),
                disabled: entretien.statut.statutId == EStatuts.Complete,
                command: () => this.modifierEntretienCorrectif(entretien)
            },
            { separator: true },
            {
                label: 'Voir le bon de travail',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('temp_mec') && entretien.bonTravail != null && entretien.bonTravail != undefined,
                command: () => this.routerService.navigateByUrl('mecanique/bontravails/' + entretien.bonTravail.bonTravailId)
            },
            {
                label: 'Créer un bon de travail',
                icon: 'pi pi-fw pi-plus',
                visible: this.estAutorise('temp_mec') && (entretien.bonTravail == null || entretien.bonTravail == undefined),
                command: _ => this.assignerEntretiensCorrectifs([entretien])
            },
            { separator: true },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-trash',
                visible: this.estAutorise('temp_mec'),
                disabled: entretien.statut.statutId == EStatuts.Complete,
                command: () => this.supprimerEntretienCorrectif(entretien)
            },
        ];

        this.menuContextuelEntretiensCorrectifs.toggle(event);
    }

    assignerEntretiensCorrectifs(entretiens: EntretienCorrectifEntite[]) {

        const ref = this.dialogService.open(AssignerEntretiensComponent, {
            data: {
                itemId: entretiens[0].item.itemId,
                itemNumero: entretiens[0].item.numero ?? this.item.value().numero,
                entretiensCorrectifs: entretiens,
                employeId: this.profilService.ProfilCourant().employeId,
                contreMaitreId: entretiens[0].item.departementMecanique?.contreMaitre?.employeId
            },
            header: `Assigner des entretiens`,
            width: '75%'
        }).onClose.subscribe((bt: BonTravailEntite) => {

            if (bt) {

                this.contexteService.Ajouter("messageInitItem", 'Bon de travail créé.');
                this.rafraichir();

                // this.selectionEntretiensCorrectifs = null;

                // //TODO
                // entretiens.forEach(ent => {
                //     ent.statut = this.sdb.Statut(EStatuts.EnCours);
                //     ent.bonTravail = bt
                // });

                // this.chargementCompleteBonsTravail = false;

                // this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Bon de travail créé.' });
            }
        });

    }

    modifierEntretienCorrectif(entretien: EntretienCorrectifEntite) {

        const ref = this.dialogService.open(DetailEntretienCorrectifComponent, {
            data: {
                entretienCorrectif: entretien
            },
            header: `Modifier un entretien correctif`,
            width: '75%'
        }).onClose.subscribe(res => {

            if (res) {
                entretien = res;
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Entretien correctif modifié.' });
            }

        });

    }

    ajouterEntretienCorrectif() {

        const ref = this.dialogService.open(DetailEntretienCorrectifComponent, {
            data: {
                entretienCorrectif: {
                    entretienCorrectifId: 0,
                    item: {
                        itemId: this.item.value().itemId
                    },
                    employe: this.profilService.ProfilCourant()
                }
            },
            header: `Ajouter un entretien correctif`,
            width: '75%'
        }).onClose.subscribe(res => {

            if (res) {
                this.item.value().entretiensCorrectifs.push(res);
                this.filtrerEntretiensCorrectifs();
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Entretien correctif créé.' });
            }

        });

    }

    creerEntretienCorrectifDepuisNote(note: NoteEntite) {
        this.Bloquer();
        const ref = this.dialogService.open(DetailEntretienCorrectifComponent, {
            data: {
                entretienCorrectif: {
                    entretienCorrectifId: 0,
                    item: {
                        itemId: this.item.value().itemId
                    },
                    description: note.description,
                    employe: this.profilService.ProfilCourant()
                }
            },
            header: `Ajouter un entretien correctif`,
            width: '75%'
        }).onClose.subscribe(res => {

            this.Debloquer();
            if (res) {
                if (!this.item.value().entretiensCorrectifs) {
                    this.item.value().entretiensCorrectifs = [];
                }
                this.item.value().entretiensCorrectifs.push(res);
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Entretien correctif créé.' });
            }

        });
    }

    supprimerEntretienCorrectif(entretien: EntretienCorrectifEntite) {

        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment supprimer l\'entretien sélectionné ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.Bloquer();
                this.entretienCorrectifService.Supprimer(entretien.entretienCorrectifId).then(res => {
                    this.Debloquer();
                    if (res.estUnSucces) {
                        this.item.value().entretiensCorrectifs = this.item.value().entretiensCorrectifs.filter(val => val.entretienCorrectifId != entretien.entretienCorrectifId);
                        this.filtrerEntretiensCorrectifs();
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Entretien supprimé.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });

            }
        });

    }

    filtrerEntretiensCorrectifs() {
        this.Bloquer();
        this.entretiensCorrectifsFiltrees = this.item.value().entretiensCorrectifs;
        if (this.selectionCategorieEntretienCorrectifs) {
            this.entretiensCorrectifsFiltrees = this.item.value().entretiensCorrectifs.filter(x => x.categorie && x.categorie.categorieEntretienId == this.selectionCategorieEntretienCorrectifs.categorieEntretienId);
        }

        this.Debloquer();
    }

    /* #endregion */

    /* #region  VAD */


    ouvrirDetailVad(vad: VadEntite) {

        const ref = this.dialogService.open(DetailVadComponent, {
            data: {
                vadId: vad.vadId
            },
            header: 'Détail de la vérification avant départ',
            width: '90%'
        });

    }

    surMenuContextuelVad(event, vad: VadEntite) {
        this.contenuMenuContextuelVads = [

        ];

        this.menuContextuelVads.toggle(event);
    }

    /* #endregion */

    /* #region  Pièces */


    surMenuContextuelPiece(event, piece: PieceUniteEntite) {
        this.contenuMenuContextuelPieces = [
            {
                label: 'Voir la pièce',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('item_detail'),
                command: () => this.naviguer('item/' + piece.piece.itemId)
            },
            {
                label: 'Voir l\'historique de pose (unité)',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('temp_mec'),
                command: () => this.historiquePosePiece(piece, false)
            },
            {
                label: 'Voir l\'historique de pose (complet)',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('temp_mec'),
                command: () => this.historiquePosePiece(piece, true)
            },
            {
                label: 'Voir les fournisseurs',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('item_fournisseurs'),
                command: () => this.consulterFournisseurs(piece)
            },
            { separator: true },
            {
                label: 'Modifier',
                icon: 'pi pi-fw pi-pencil',
                visible: this.estAutorise('temp_mec') || this.estAutorise('piece_associer'),
                command: () => this.modifierPiece(piece)
            },
            { separator: true },
            {
                label: 'Supprimer',
                icon: 'pi pi-fw pi-trash',
                visible: this.estAutorise('temp_mec') || this.estAutorise('piece_associer'),
                command: () => this.supprimerPiece(piece)
            },
        ];

        this.menuContextuelPieces.toggle(event);

    }

    ajouterPiece() {
        const refSelectionPiece = this.dialogService.open(SelectionSimplePieceComponent, {
            data: {
                diversPermis: false
            },
            header: 'Sélection d\'une pièce',
            width: '95%'
        }).onClose.subscribe((resSelectionPiece: ItemMin) => {

            if (resSelectionPiece) {

                

                const refPieceUnite = this.dialogService.open(DetailPieceUniteComponent, {
                    data: {
                        unite: this.ItemsService.ItemVersItemMin(this.item.value()),
                        piece: resSelectionPiece,
                        obligatoire: false
                    },
                    header: 'Détail d\'une pièce',
                    width: '95%'
                }).onClose.subscribe((resDetailPiece: PieceUniteEntite) => {

                    if (resDetailPiece) {

                        this.item.value().pieces.push(resDetailPiece);
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: `La pièce '${resDetailPiece.piece.description} (${resDetailPiece.piece.numero})' a été ajouté.` });

                    }

                });

            }

        });
    }

    modifierPiece(piece: PieceUniteEntite) {
        const refPieceUnite = this.dialogService.open(DetailPieceUniteComponent, {
            data: {
                pieceUnite: piece,
                unite: this.ItemsService.ItemVersItemMin(this.item.value()),
                piece: piece.piece,
                obligatoire: false
            },
            header: 'Détail d\'une pièce',
            width: '95%'
        }).onClose.subscribe((resDetailPiece: PieceUniteEntite) => {

            if (resDetailPiece) {
                piece.categorieEntretien = resDetailPiece.categorieEntretien;
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `La pièce '${resDetailPiece.piece.description} (${resDetailPiece.piece.numero})' a été modifiée.` });

            }

        });
    }

    supprimerPiece(piece: PieceUniteEntite) {

        this.confirmationService.confirm({
            target: event.target,
            message: 'Voulez-vous vraiment supprimer la pièce sélectionnée ?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.Bloquer();
                this.pieceService.Supprimer(piece.pieceUniteId).then(res => {
                    this.Debloquer();
                    if (res.estUnSucces) {
                        this.item.value().pieces = this.item.value().pieces.filter(val => val.pieceUniteId != piece.pieceUniteId);
                        this.filtrerPieces();
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Pièce supprimée.' });
                    } else {
                        res.messages.forEach(x => {
                            this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                        });
                    }
                });
            }
        });
    }

    historiquePosePiece(piece: PieceUniteEntite, complet: boolean) {
        const ref = this.dialogService.open(HistoriquePosePieceComponent, {
            data: {
                pieceId: piece.piece.itemId,
                uniteId: complet ? null : this.item.value().itemId
            },
            header: 'Historique de pose',
            width: '90%'
        });
    }

    consulterFournisseurs(piece: PieceUniteEntite) {
        const ref = this.dialogService.open(ConsulterFournisseursComponent, {
            data: {
                itemId: piece.piece.itemId,
                afficherSelection: false,
                afficherCommander: true
            },
            header: 'Consulter les fournisseurs',
            width: '50%'
        }).onClose.subscribe((res: PrixFournisseurEntite) => {
            if (res) {

                const ref2 = this.dialogService.open(CreationCommandeComponent, {
                    data: {
                        itemId: res.item.itemId,
                        numeroItem: res.item.numero,
                        descriptionItem: res.item.description,
                        fournisseurId: res.fournisseur.fournisseurId,
                        nomFournisseur: res.fournisseur.nom,
                        numeroFournisseur: res.fournisseur.numero,
                        numeroItemFournisseur: res.numeroFournisseur,
                        prix: res.prix,
                        //selectionCodeProjet: codeProjetId,
                        //selectionCodeActivite: item.codeActivite?.codeActiviteId

                    },
                    header: 'Création d\'un bon de commande',
                    width: '60%'
                }).onClose.subscribe((res2: ResultatCreationBonCommande) => {
                    if (res2) {
                        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'item a été ajouté au bon de commande.' });
                        /* if (res2.redirection) {
                            this.routerService.navigateByUrl('achat/' + res2.bonCommandeId);
                        } else {
                            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'item a été ajouté au bon de commande.' });
                        } */
                    }
                });
            }
        });
    }

    filtrerPieces() {
        this.Bloquer();
        this.piecesFiltrees = this.item.value().pieces;
        if (this.selectionCategorieEntretien) {
            this.piecesFiltrees = this.item.value().pieces.filter(x => x.categorieEntretien && x.categorieEntretien.categorieEntretienId == this.selectionCategorieEntretien.categorieEntretienId);
        }

        this.Debloquer();
    }

    surMenuContextuelHistoriqueAchatPieces(event, itemBdc: ItemBonCommande) {
        //this.selectionDocument = doc;

        this.contenuMenuContextuelHistoriqueAchatPieces = [
            {
                label: 'Voir le bon de commande',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('bdc_detail'),
                command: () => this.routerService.navigateByUrl('achat/' + itemBdc.bonCommande.bonCommandeId)
            }
        ];

        this.menuContextuelHistoriqueAchatPieces.toggle(event);
    }

    surMenuContextuelHistoriquePieces(event, historique: HistoriqueItem) {
        //this.selectionDocument = doc;

        this.contenuMenuContextuelHistoriquePieces = [
            {
                label: 'Voir la réquisition',
                icon: 'pi pi-fw pi-eye',
                visible: this.estAutorise('requisition_detail'),
                command: () => this.routerService.navigateByUrl('transport/' + historique.requisition.requisitionId)
            }
        ];

        this.menuContextuelHistoriquePieces.toggle(event);
    }

    /* #endregion */

    /* #region  QR Code et Impression */

    generateQrCodeData(): void {
        // Generate the current page URL for the QR code
        const currentUrl = window.location.origin + '/item/' + this.itemId + '?tab=0';
        this.qrCodeData = currentUrl;
        this.currentDate = new Date();
        this.showQrCode = true;

        setTimeout(() => {
            const selector = document.querySelector('#qr-print-section')
            selector.classList.add('magictime', 'slideUpReturn')
        }, 10);
        
        // Generate QR code image for printing with improved timing
        setTimeout(async () => {
            try {
                await this.generateQrCodeImage();
            } catch (error) {
                console.error('Failed to generate QR code image:', error);
                this.messageService.add({ 
                    severity: 'warn', 
                    summary: 'Avertissement', 
                    detail: 'Le code QR pourrait ne pas s\'imprimer correctement. Essayez de le régénérer.' 
                });
            }
        }, 300);
    }

    generateQrCodeImage(): Promise<void> {
        return new Promise((resolve, reject) => {
            const attemptConversion = (attempts: number = 0) => {
                const maxAttempts = 10;
                const qrElement = document.querySelector('qrcode canvas') as HTMLCanvasElement;
                
                if (qrElement && qrElement.width > 0 && qrElement.height > 0) {
                    try {
                        // Ensure the canvas is fully drawn
                        const context = qrElement.getContext('2d');
                        if (context) {
                            // Wait for any pending drawing operations
                            setTimeout(() => {
                                try {
                                    this.qrCodeImageUrl = qrElement.toDataURL('image/png');
                                    console.log('QR code image generated successfully');
                                    resolve();
                                } catch (error) {
                                    console.error('Error converting canvas to image:', error);
                                    if (attempts < maxAttempts) {
                                        setTimeout(() => attemptConversion(attempts + 1), 200);
                                    } else {
                                        reject(error);
                                    }
                                }
                            }, 50);
                        } else {
                            if (attempts < maxAttempts) {
                                setTimeout(() => attemptConversion(attempts + 1), 200);
                            } else {
                                reject(new Error('Canvas context not available'));
                            }
                        }
                    } catch (error) {
                        console.error('Error accessing canvas:', error);
                        if (attempts < maxAttempts) {
                            setTimeout(() => attemptConversion(attempts + 1), 200);
                        } else {
                            reject(error);
                        }
                    }
                } else {
                    if (attempts < maxAttempts) {
                        setTimeout(() => attemptConversion(attempts + 1), 200);
                    } else {
                        reject(new Error('QR code canvas not found or not ready'));
                    }
                }
            };
            
            attemptConversion();
        });
    }

    async printQrCodeSection(): Promise<void> {
        // Ensure we have the QR code image with retry logic
        if (!this.qrCodeImageUrl) {
            try {
                await this.generateQrCodeImage();
            } catch (error) {
                console.error('Failed to generate QR code image for printing:', error);
                this.messageService.add({ 
                    severity: 'error', 
                    summary: 'Erreur d\'impression', 
                    detail: 'Impossible de générer l\'image du code QR. Veuillez réessayer.' 
                });
                return;
            }
        }

        // Double-check we have a valid image
        if (!this.qrCodeImageUrl || !this.qrCodeImageUrl.startsWith('data:image/')) {
            this.messageService.add({ 
                severity: 'error', 
                summary: 'Erreur d\'impression', 
                detail: 'L\'image du code QR n\'est pas valide. Veuillez régénérer le code QR.' 
            });
            return;
        }

        const printWindow = window.open('', '_blank');
        if (printWindow) {
            const isHorizontal = this.printFormat === 'ptouch';
            const styles = isHorizontal ? this.getPtouchStyles() : this.getNormalStyles();
            
            const htmlContent = `
                <html>
                    <head>
                        <title>Code QR - ${this.item.value().numero}</title>
                        <style>${styles}</style>
                    </head>
                    <body>
                        <div class="qr-section">
                            <div class="item-info">
                                <div class="item-number">${this.item.value().numero}</div>
                                <div class="item-description">${this.item.value().description}</div>
                                <div class="item-category">${this.item.value().categorie?.nom || ''}</div>
                            </div>
                            <div class="qr-code">
                                <img src="${this.qrCodeImageUrl}" alt="Code QR" onload="window.print();" onerror="console.error('Failed to load QR code image');" />
                            </div>
                        </div>
                    </body>
                </html>
            `;
            
            printWindow.document.write(htmlContent);
            printWindow.document.close();
        }
    }

    getPtouchStyles(): string {
        return `
            @page { 
                size: landscape; 
                margin: 5mm;
            }
            body { 
                font-family: Arial, sans-serif; 
                margin: 0;
                padding: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 100vh;
            }
            .qr-section {
                border: 2px dashed #333;
                padding: 8px;
                display: flex;
                align-items: center;
                gap: 10px;
                max-width: 100%;
                background: white;
            }
            .item-info {
                flex: 1;
                text-align: left;
            }
            .item-number {
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 4px;
                line-height: 1.2;
            }
            .item-description {
                font-size: 12px;
                margin-bottom: 2px;
                line-height: 1.2;
            }
            .item-category {
                font-size: 10px;
                color: #666;
                font-style: italic;
                line-height: 1.2;
            }
            .qr-code {
                flex-shrink: 0;
            }
            .qr-code img {
                width: 80px;
                height: 80px;
            }
            .generated-info {
                display: none;
            }
        `;
    }

    getNormalStyles(): string {
        return `
            body { 
                font-family: Arial, sans-serif; 
                margin: 20px;
                text-align: center;
            }
            .qr-section {
                border: 2px dashed #333;
                padding: 20px;
                margin: 10px;
                display: inline-block;
                background: white;
            }
            .item-info {
                margin-bottom: 15px;
            }
            .item-number {
                font-size: 24px;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .item-description {
                font-size: 18px;
                margin-bottom: 10px;
            }
            .item-category {
                font-size: 14px;
                color: #666;
                font-style: italic;
            }
            .qr-code {
                margin: 15px 0;
            }
            .qr-code img {
                width: 200px;
                height: 200px;
            }
            .generated-info {
                font-size: 12px;
                color: #666;
                margin-top: 15px;
                border-top: 1px solid #ccc;
                padding-top: 10px;
            }
            .generated-info p {
                margin: 5px 0;
            }
            .scan-info {
                font-style: italic;
            }
        `;
    }

    toggleQrCode(): void {
        if (!this.showQrCode) {
            this.generateQrCodeData();
        } else {
            this.showQrCode = false;
        }
    }

    togglePrintFormat(): void {
        this.printFormat = this.printFormat === 'normal' ? 'ptouch' : 'normal';
    }

    async refreshQrCodeImage(): Promise<void> {
        try {
            this.qrCodeImageUrl = ''; // Clear existing image
            await this.generateQrCodeImage();
            this.messageService.add({ 
                severity: 'success', 
                summary: 'Succès', 
                detail: 'Image du code QR régénérée avec succès.' 
            });
        } catch (error) {
            console.error('Failed to refresh QR code image:', error);
            this.messageService.add({ 
                severity: 'error', 
                summary: 'Erreur', 
                detail: 'Impossible de régénérer l\'image du code QR.' 
            });
        }
    }

    /* #endregion */


    get EStatuts(): typeof EStatuts {
        return EStatuts;
    }

    get eTypeFavori(): ETypeFavori {
        return ETypeFavori.Item;
    }
}
